import request from "@/utils/request";

export default function agentEditGroup(data) {
    return request({
        url: `/device/deviceGroup/agentEditGroup`,
        method: 'post',
        data,
    })
}
